import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import { DOCUMENT } from '@angular/platform-browser';
import {NewsService} from "../../services/news.service";
declare var jquery:any;
declare var $ :any;
@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.css']
})
export class BannerComponent implements OnInit, AfterViewInit {

  banner: any = [{imagen:'',titulo:'',texto:''}];
  domain: string;
  constructor(private news: NewsService) {

  }
  add(){
    let head = document.getElementsByTagName('head').item(0);

      let script = document.createElement('script');
      script.setAttribute('type', 'text/javascript');
      script.setAttribute('src', '/assets/js/sliderref.js');
      head.appendChild(script);

  }
  ngOnInit() {
    this.news.getConfig().subscribe(response => {
        console.log('FILE_JSON', response);
        this.domain = response.back_domain;
      },
      error => {
        console.log(<any>error);
      });
  }
  ngAfterViewInit() {
    this.news.getBanner().subscribe(response => {
        this.banner= response;
        console.log('BANNER',this.banner);
        //this.banner[0].imagen='/assets/11.jpg';
        //this.banner[1].imagen='/assets/2.jpg';
        //this.banner[2].imagen='/assets/3.jpg';
        setTimeout(()=>{
          this.add();
        },200);


      },
      error => {
        console.log(<any>error);
      });

  }
}



// WEBPACK FOOTER //
// ./src/app/layouts/banner/banner.component.ts